module.exports = __webpack_public_path__ + "static/tattoos-hero-db524466fe3e044e4b44103adbb077fb.jpg";